<template>
  <v-card>
    <v-card-text>
      <v-form ref="stepForm">
        <v-row>
          <v-col cols="12">
            <int-editor v-model="mobile" dense outlined class="rounded-0" autocomplete="off" label="手机号" :rules="[rules.required,rules.mobile]"></int-editor>
          </v-col>
          <v-col cols="12">
            <int-editor validate-on-blur v-model="smsCode" dense label="验证码" outlined class="rounded-0" autocomplete="off" :rules="[rules.required]">
              <template v-slot:append>
                <div style="margin-top:-3px;">
                  <v-btn color="primary" small class="caption" :disabled="smsCodeDisabled" elevation=0 @click="onGetForgotSmsCode">{{smsCodeText}}</v-btn>
                </div>
              </template>
            </int-editor>
          </v-col>
          <v-col cols="8">
            <v-text-field v-model="verifyCode" dense autocomplete="off" outlined class="rounded-0" label="图形验证码" :rules="[rules.required]"></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-img :src="verifyCodeUrl" @click="onRefreshVerifyCode" contain height="37"></v-img>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="primary" @click="onNext">下一步
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { required, mobile } from '@/plugins/rules';
import { getForgotSmsCode, forgotVerify } from '@/plugins/api';

export default {
  data () {
    return {
      mobile: null,
      smsCode: null,
      verifyCode: null,
      verifyCodeUrl: `${this.Utility.userApi}/api/pub/verify/code?ts=${new Date().getTime()}`,
      smsCodeText: '获取验证码',
      smsCodeDisabled: false,
      rules: {
        required: required(), mobile: mobile()
      }
    }
  },
  methods: {
    onRefreshVerifyCode () {
      this.verifyCodeUrl = `${this.Utility.userApi}/api/pub/verify/code?ts=${new Date().getTime()}`;
    },
    onNext () {
      if (!this.$refs.stepForm.validate()) return;
      let param = { mobile: this.mobile, smsCode: this.smsCode, verifyCode: this.verifyCode };
      forgotVerify(param).then(res => {
        this.$emit('change', { mobile: this.mobile, token: res.data })
      })
    },
    onGetForgotSmsCode () {
      if (!this.mobile) {
        this.$message.error('请填写手机号');
        return;
      }
      this.smsCodeDisabled = true;
      let i = 60;
      let removeTimer = () => {
        clearInterval(smsCodeTimer);
        smsCodeTimer = undefined;
        this.smsCodeDisabled = false;
        this.smsCodeText = '获取验证码';
      }
      let smsCodeTimer = setInterval(() => {
        if (i < 0) removeTimer();
        else this.smsCodeText = `重新发送${i--}`;
      }, 1000);
      getForgotSmsCode(this.mobile).then((res) => {
        if (res.status < 0) {
          this.$message.error(res.message);
          removeTimer();
          return;
        }
        this.$message.success('验证码已发送，请注意查收');
      })
    }
  }
}
</script>